<template>
	<div id="app" :class="classes">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App',
	metaInfo() {
		return {
			title: this.$t('main.title'),
			meta: [
				{ name: 'description', content: this.$t('main.meta-desc') },
				{ name: 'keywords', content: this.$t('main.meta-keyword') },
				{ property: 'og:site_name', content: this.$t('main.title') },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'http://www.nexon.com/' },
				{ property: 'og:title', content: this.$t('main.title') },
				{ property: 'og:description', content: this.$t('main.meta-desc') },
				{ property: 'og:image', content: 'https://web.nxfs.nexon.com/nexon-logo.png' },
				{ itemprop: 'name', content: this.$t('main.title') },
				{ itemprop: 'description', content: this.$t('main.meta-desc') },
				{ itemprop: 'image', content: 'https://web.nxfs.nexon.com/nexon-logo.png' },
			],
		};
	},
	computed: {
		classes() {
			return [this.region, this.language];
		},
		region() {
			return environment.region;
		},
		language() {
			return this.$i18n.locale;
		},
		memberShipNo() {
			return this.region === 'global' ? 1 : this.region === 'th' ? 3 : this.region === 'tw' ? 4 : this.region === 'sea' ? 5 : null;
		},
	},
	mounted() {
		if (process.env.NODE_ENV !== 'dev') {
			window.version = `Current Version => ${process.env.VUE_APP_VERSION}`;
		}
	},
};
</script>

<style lang="less">
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
@import './less/global';
@import './less/responsive';
</style>
